import { Button, Tag, WImage, WLink } from '@components/atoms'
import { MenuItemType } from '@utils/types'
import { useTrans } from '../../../hooks'
import styles from './GenericCard.module.sass'

interface Props {
  item: MenuItemType
  className?: string
}

const GenericCard = (props: Props) => {
  const { item = undefined, className = '' } = props

  const t = useTrans()

  const getContent = () => (
    <div className={`${styles.layout}`}>
      <div className={styles.layoutMediaBox}>
        {!!item.tag && <Tag label={item.tag} className={styles.tag} />}
        <div className={`${styles.imageBox}`}>
          {!!item.image && (
            <WImage
              src={item.image}
              maxWidth={303}
              maxHeight={280}
              objectFit="cover"
              alt={item.imageAlt}
              title={item.imageAlt}
            />
          )}
        </div>
      </div>
      <div className={styles.main}>
        {!!item.name && <h3 className={styles.title}>{item.name}</h3>}
        {!!item.url && (
          <Button label={t('Leggi di più')} size="lg" variant="ghost" className={styles.button} />
        )}
      </div>
    </div>
  )

  return item ? (
    item?.url ? (
      <WLink href={item.url} className={`${styles.root} ${className}`}>
        {getContent()}
      </WLink>
    ) : (
      <div className={`${styles.root} ${className}`}>{getContent()}</div>
    )
  ) : (
    <></>
  )
}

export default GenericCard
